import React, { useState } from "react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import { useEffect } from "react";


export default function CarouselImages(props) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const newItems = props.PhotoGallery.map((item) => (

      <img
        key={item}
        component="img"
        alt="img"
        onDragStart={handleDragStart}
        role="presentation"
        src={item}
        style={{
          width: "100%",
          height: window.innerWidth > 900 ? "500px" : "330px",
          objectFit: window.innerWidth > 900 ? "cover" : "scale-down",
          objectPosition: "50% 10%",
        }}
      />

    ));

    setItems(newItems);
  }, [props.PhotoGallery]);


  const handleDragStart = (e) => e.preventDefault();


  return (
    <>

      <AliceCarousel
        mouseTracking
        items={items}
        autoPlay={items.length > 1 ? true : false}
        infinite
        autoPlayInterval={1500}
        disableDotsControls
      />

    </>


  );
}


